import { Ref, watch } from 'vue';
import { HekateDisplayField, Trans } from 'www-shared';

export default class SubmitFieldCoordinator {
  /** True if if we should disable the submit button */
  private isSubmitDisabled: Ref<boolean>;

  private readonly onSubmitForm: (evt: Event) => void;

  private readonly field: Ref<HekateDisplayField>;

  private readonly submitText: string;

  constructor({
    field,
    isRecaptchaSolved,
    isSubmitDisabled,
    onSubmitForm,
    submitText,
  }: {
    field: Ref<HekateDisplayField>,
    isRecaptchaSolved: Ref<boolean>,
    isSubmitDisabled: Ref<boolean>,
    onSubmitForm: (evt: Event) => void,
    submitText: string,
  }) {
    this.onSubmitForm = onSubmitForm;
    this.isSubmitDisabled = isSubmitDisabled;
    this.field = field;
    this.submitText = submitText;

    watch(isRecaptchaSolved, (newVal) => {
      if (newVal) {
        this.field.value.errorMessages = [];
      } else {
        this.field.value.errorMessages = [
          {
            message: Trans.byKey('recaptchaRequired'),
          },
        ];
      }
    });
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  public setup() {
    return {
      isSubmitDisabled: this.isSubmitDisabled,
      onClickSubmit: this.onSubmitForm.bind(this),
      submitText: this.submitText,
    };
  }
}
